import { ColumnDef } from "@tanstack/react-table";
import { TIVisibleFeatures, VisibleFeature } from "../../types/types";

// Define the structure for substation properties
export interface SubstationProperties {
    "Power Flow Case": string;
    "Power Flow Area": string;
    BusName: string;
    SubstationName: string;
    "Bus Type": string;
    Voltage: number;
    "Transmission Zone": string;
    Interconnect: string;
    "Power Flow NERC Region": string;
    "Nearest LMP": string;
}

// Define the specific substation feature type
export interface SubstationFeature extends VisibleFeature {
    properties: SubstationProperties;
}

// Type guard to check if a feature is a substation
export function isSubstationFeature(
    feature: VisibleFeature
): feature is SubstationFeature {
    return feature.type === TIVisibleFeatures.bus && "properties" in feature;
}

// Transform a SubstationFeature into a display format
export interface SubstationDisplay {
    powerflowcase: string;
    powerflowarea: string;
    name: string;
    substationname: string;
    bustype: string;
    voltage: number;
    transmissionzone: string;
    interconnection: string;
    nercregion: string;
    nearbypnode: string;
}

// Helper function to transform feature data into display format
export function transformSubstationFeature(
    feature: SubstationFeature
): SubstationDisplay {
    return {
        powerflowcase: feature.properties["Power Flow Case"] || "N/A",
        powerflowarea: feature.properties["Power Flow Area"] || "N/A",
        substationname: feature.properties.SubstationName || "N/A",
        bustype: feature.properties["Bus Type"] || "N/A",
        name: feature.properties.BusName || "N/A",
        voltage: feature.properties.Voltage || 0,
        transmissionzone: feature.properties["Transmission Zone"] || "N/A",
        interconnection: feature.properties.Interconnect || "N/A",
        nercregion: feature.properties["Power Flow NERC Region"] || "N/A",
        nearbypnode: feature.properties["Nearest LMP"] || "N/A",
    };
}

export const substationColumns: ColumnDef<SubstationDisplay>[] = [
    {
        accessorKey: "powerflowcase",
        header: "BaseCase",
        enableSorting: true,
    },
    {
        accessorKey: "powerflowarea",
        header: "Area",
        enableSorting: true,
    },
    {
        accessorKey: "name",
        header: "BusName",
        enableSorting: true,
    },
    {
        accessorKey: "substationname",
        header: "StationName",
        enableSorting: true,
    },
    {
        accessorKey: "bustype",
        header: "BusType",
        enableSorting: true,
    },
    {
        accessorKey: "voltage",
        header: "Voltage (kV)",
        enableSorting: true,
    },
    {
        accessorKey: "transmissionzone",
        header: "Transmission Zone",
        enableSorting: true,
    },
    {
        accessorKey: "interconnection",
        header: "Interconnection",
        enableSorting: true,
    },
    {
        accessorKey: "nercregion",
        header: "NERC Region",
        enableSorting: true,
    },
    {
        accessorKey: "nearbypnode",
        header: "Nearby Pnode",
        enableSorting: true,
    },
];
